import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, errMsg, fmtKST } from "@/lib/api";

const ROWS = [["First Name", "first_name"], ["Middle Name", "middle_name"], ["Last Name", "last_name"], ["Date of Birth (YYMMDD)", "dob"], ["Email", "email"],
  ["Phone Number", "phone"], ["Nationality", "nationality"], ["Member", "member"], ["Call Apps", "apps"], ["HelloLive Username", "hellolive_username"],
  ["HelloLive Password", "hellolive_password"], ["KakaoTalk Username", "kakaotalk_username"], ["Line Username", "line_username"]];

export const FancallInfoView = ({ w, onClose, onChanged }) => {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    if (!w) return;
    setInfo(null);
    api.get(`/raffles/${w.raffle_id}/fancall-info/${w.joiner_id}`).then((r) => setInfo(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [w]);
  const unlock = async () => {
    if (!window.confirm(`Let ${w.joiner_name} edit and resend their Fancall Information?`)) return;
    try {
      await api.post(`/raffles/${w.raffle_id}/fancall-info/${w.joiner_id}/unlock`);
      toast.success("Unlocked; the winner can send it again");
      onChanged();
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open={!!w} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="fancall-info-view" className="bg-zinc-950 border-zinc-800 text-white max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{w?.joiner_name} · Fancall Information</DialogTitle>
          <DialogDescription className="text-zinc-400">{w?.round_name}{info ? ` · sent ${fmtKST(info.submitted_at)}` : ""}</DialogDescription>
        </DialogHeader>
        {!info ? <div className="text-sm text-zinc-500">Loading…</div> : (
          <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1.5 text-sm">
            {ROWS.filter(([, k]) => (Array.isArray(info[k]) ? info[k].length : info[k])).map(([label, k]) => (
              <div key={k} className="contents">
                <dt className="text-zinc-500">{label}</dt>
                <dd data-testid={`fancall-view-${k}`} className="break-all select-all">{Array.isArray(info[k]) ? info[k].join(", ") : info[k]}</dd>
              </div>
            ))}
          </dl>
        )}
        <DialogFooter>
          {info && !info.unlocked && <Button variant="ghost" data-testid="fancall-info-unlock" onClick={unlock}>Unlock for edits</Button>}
          <Button data-testid="fancall-info-view-close" onClick={onClose}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
